<template>
  <el-form :model="model" label-width="120px" ref="form" :rules="rules">
    <el-form-item>
      <el-alert :title="error" type="error" v-if="error" :closable="false" />
      <el-alert
        :title="sendCodeMessage"
        type="error"
        v-if="sendCodeError"
        :closable="false"
      />
    </el-form-item>

    <el-form-item
      :label="$t('login.REGISTER.username')"
      prop="username"
      style="margin-bottom: 30px"
    >
      <el-input
        v-model="model.username"
        size="large"
        :placeholder="$t('login.REGISTER.inputusername')"
        prefix-icon="User"
      />
    </el-form-item>

    <el-form-item
      :label="$t('login.REGISTER.mobile')"
      prop="mobile"
      style="margin-bottom: 30px"
    >
      <el-input
        v-model="model.mobile"
        size="large"
        :placeholder="$t('login.REGISTER.inputmobile')"
        prefix-icon="User"
      />
    </el-form-item>
    <el-form-item
      :label="$t('login.REGISTER.password')"
      prop="password"
      style="margin-bottom: 30px"
    >
      <el-input
        type="password"
        v-model="model.password"
        size="large"
        :placeholder="$t('login.REGISTER.inputpassword')"
        prefix-icon="Lock"
      />
    </el-form-item>
    <el-form-item :label="$t('login.REGISTER.code')" prop="code">
      <el-row :gutter="10">
        <el-col :span="20">
          <el-input
            v-model="model.code"
            size="large"
            :placeholder="$t('login.REGISTER.inputsmscode')"
            prefix-icon="Lock"
          />
        </el-col>
        <el-col :span="4">
          <el-button
            size="large"
            :disabled="totalCountdownTime < 60"
            @click="sendSMSCode"
          >
            {{ btnSMScontent }}
          </el-button>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item>
      <el-checkbox
        v-model="model.acceptLicense"
        :label="$t('login.REGISTER.useragreement')"
      />
    </el-form-item>
    <el-form-item>
      <el-button
        type="primary"
        size="large"
        style="width: 100%"
        :loading="loading"
        :disabled="!model.acceptLicense"
        @click="register"
      >
        {{ $t('login.REGISTER.title') }}
      </el-button>
    </el-form-item>
    <div style="text-align: right">
      <el-button link @click="() => this.$emit('return_to_login')">
        {{ $t('login.REGISTER.returntologin') }}
      </el-button>
    </div>
  </el-form>
</template>
<script>
import axios from 'axios';
import SmsMixin from './SmsMixin';
import {
  validateMobile,
  validateUsername,
  validatePassword,
} from './validator';
const MAPSCLOUD_AUTH_SERVER = process.env.VUE_APP_MAPSCLOUD_AUTH_SERVER;

export default {
  mixins: [SmsMixin],
  data() {
    return {
      rules: {
        username: [
          { required: true, validator: validateUsername, trigger: 'blur' },
        ],
        mobile: [
          { required: true, validator: validateMobile, trigger: 'blur' },
        ],
        password: [
          { required: true, validator: validatePassword, trigger: 'blur' },
        ],
        code: [
          {
            required: true,
            message: this.$t('login.REGISTER.inputcode'),
            trigger: 'blur',
          },
        ],
      },
      model: {
        username: null,
        mobile: null,
        password: null,
        code: null,
        acceptLicense: false,
      },
      loading: false,
      error: false,
      sendSmsUrl: '/v1.0/user/mobile/register/code',
    };
  },
  methods: {
    async register() {
      let isValid = false;
      await this.$refs.form.validate(
        (valid) => (isValid = valid),
      );
      if (!isValid) return;
      this.loading = true;
      this.error = false;

      const url = '/v1.0/user/mobile/register';
      const reqConf = {
        method: 'POST',
        baseURL: MAPSCLOUD_AUTH_SERVER,
        url,
        data: {
          username: this.model.username,
          mobile: this.model.mobile,
          password: this.model.password,
          code: this.model.code,
          acceptLicense: this.model.acceptLicense,
        },
      };
      try {
        const { data } = await axios(reqConf);
        if (data.status == 0) {
          const token = await this.autoRegLogin(this.username, this.password);
          if (token) {
            await this.registerCartoUser(token)
            this.$emit('return_to_login');
          }
        } else {
          this.error = true;
        }
        this.loading = false;
      } catch (err) {
        this.error = true;
        this.loading = false;
        console.error(err);
      }
    },
    async autoRegLogin() {
      const url = '/v1.0/user/auto_reg_login';
      const reqConf = {
        method: 'POST',
        baseURL: MAPSCLOUD_AUTH_SERVER,
        url,
        data: {
          username: this.model.username,
          password: this.model.password,
        },
      };
      try {
        const {
          data: { status, data },
        } = await axios(reqConf);
        if (status == 0) {
          const { access_token } = data;
          return Promise.resolve(access_token);
        } else {
          this.error = data.message;
          return Promise.resolve(null);
        }
      } catch (err) {
        console.error(err);
        return Promise.resolve(null);
      }
    },

    //mapsCloud注册成功后,创建cartouser
    async registerCartoUser(mapsCloudToken) {
      const COOKIE_DOMAIN = window.location.host.replace('globallayer', '');
      document.cookie = `mapscloud_auth=${mapsCloudToken}; domain=${COOKIE_DOMAIN}`;
      this.$store.dispatch("auth/loginCartodb")
    },
  },
};
</script>